// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from '@/vuex/store';
import ViewUI from 'view-design';
import Viewer from 'v-viewer';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import * as filters from '@/filters';
import _ from 'lodash';
import $ from 'jquery';
// import style
import 'view-design/dist/styles/iview.css';
import 'viewerjs/dist/viewer.css';
import 'swiper/css/swiper.css';
import '../static/iconfonts/iconfont.css';
import '../static/otherIcon/style.css';
import '../static/indexIcon/style.css';
import '../static/indexIcon-1/style.css';
import '@/styles/iview.ex.scss';
import '@/styles/main.scss';

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
Vue.use(VueAwesomeSwiper, {});
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
});
Vue.use(ViewUI);
Vue.config.productionTip = false;
Vue.prototype._ = _;
Vue.prototype.$ = $;

/* router */
router.beforeEach((to, from, next) => {
  ViewUI.LoadingBar.start();
  next();
});
router.afterEach(route => {
  ViewUI.LoadingBar.finish();
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js